<nb-card class="modal-full">
  <nb-card-header>
    <div class="start inline-flex">
      <div class="">Edit character</div>
    </div>
    <div class="end ml-4">
    </div>
  </nb-card-header>
  <nb-card-body>
    <div class="form-group">
      <!--<label *ngIf="istemplate" for="toogleA" class="flex items-center cursor-pointer">
        <div class="relative">
          <input id="toogleA" type="checkbox" [(ngModel)]="_model.customObject" class="sr-only"/>
          <div class="w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
          <div class="dot absolute w-6 h-6 bg-white rounded-full shadow -left-1 -top-1 transition"></div>
        </div>
        <div class="ml-3">Custom Object</div>
      </label>
      <nb-toggle *ngIf="istemplate" status="info" [(ngModel)]="_model.customObject">Custom Object</nb-toggle>-->
      </div>
    <div class="form-group">
      <label for="labels">Label</label>
      <multilang-editor [model]="_model.labels" editMode="true" [htmlMode]="false" [simple]="true" 
        [languages]="languages" [defaultLang]="game?.defaultLang"></multilang-editor>
    </div>
    <div class="form-group">
      <label for="labels">Description</label>
      <multilang-editor [model]="_model.description" editMode="true" [htmlMode]="true" 
        [languages]="languages" [defaultLang]="game?.defaultLang"></multilang-editor>
    </div>
    <div class="form-group">
      <label class="control-label">Default voice id</label>
      <input class="form-control" id="ttsVoiceId" placeholder="elevenlabs voice id" type="text" name="name"
        [(ngModel)]="_model.ttsVoiceId" [ngModelOptions]="{standalone: true}">
    </div>
    <div class="form-group">
      <label class="control-label">Language specific voice id</label>
      <multilang-editor [model]="_model?.languageTtsVoiceId" [simple]="true" [editMode]="true" [htmlMode]="false" 
        [languages]="languages" [defaultLang]="game?.defaultLang"></multilang-editor>
    </div>
    <div class="card-block">
      <label>Character picture</label>
      <div class="row">
        <div class="col-3 form-group" style="text-align:center;" *ngIf="!_model.id">
          Please save new character first
        </div>
        <div class="col-3" *ngIf="_model.id">
          <!--<image-uploader [activeColor]="'orangered'" [baseColor]="'lightgray'" [maxFileSizeMb]="15"
            [progress]="progressMap['OBJECT']" (fileUpdated)="handleFileUpdated($event, null)"
            [imageUrl]="_model?.pictureUrl"></image-uploader>-->
            <app-media-selector type="image" [gameId]="gameId" [templateId]="templateId" [fileURL]="_model?.fileURL" (mediaUpdated)="imageUpdated($event)"></app-media-selector>
        </div>
        <!--<div class="col-3 justify-content-end pr-5" *ngIf="_model.pictureUrl">
          <button nbButton ghost status="danger" (click)="deletePicture(null)">
            <nb-icon icon="trash"></nb-icon>
          </button>
        </div>-->
      </div>
    </div>

    <nb-card class="my-3" *ngIf="_model.id">
      <nb-card-header class="params-title">Mood board</nb-card-header>
      <nb-card-body class="bg-light">
        <div class="row justify-content-end mb-3 mr-3">
          <button type="button" class="btn btn-success" (click)="addMood($event)">Add</button>
        </div>
        
        <table class="table" *ngIf="_model.moods.length>0">
          <thead>
            <tr>
              <td>Mood</td>
              <td>Image</td>
              <td>Action</td>
            </tr>
          </thead>
          <tbody>
            <tr class="fork-selection" *ngFor="let mood of _model.moods; let i = index" (click)="editMood(mood)" [ngClass]="{'selected':currentMoodIdx == i}">
              <td class="col">{{mood.name}}</td>
              <td class="col-2">
                <img class="w-48 h-auto" [src]="mood.fileURL" alt="">
              </td>
              <td class="col-3">
                <button nbButton outline size="tiny" status="info" *ngIf="(_model.moods.length - 1) !== i" (click)="changePosition(i, i+1)">
                  <nb-icon icon="arrow-ios-downward-outline"></nb-icon>
                </button>
                <button nbButton size="tiny" status="info" *ngIf="i !== 0" outline (click)="changePosition(i, i-1)">
                  <nb-icon icon="arrow-ios-upward-outline"></nb-icon>
                </button>
              </td>
              <td class="col-sm-3">
                <button nbButton ghost status="danger" (click)="deleteMood(i)">
                  <nb-icon icon="trash"></nb-icon>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <div *ngIf="currentMood">
          <h4>Current mood details</h4>
          <div class="form-group">
            <label for="name">Name</label>
              <input class="form-control" type="text" [(ngModel)]="currentMood.name"
                [ngModelOptions]="{standalone: true}">
          </div>
          <div class="form-group">
            <label class="control-label">Default voice id</label>
            <input class="form-control" id="ttsVoiceId" placeholder="elevenlabs voice id" type="text" name="name"
              [(ngModel)]="currentMood.ttsVoiceId" [ngModelOptions]="{standalone: true}">
          </div>
          <div class="form-group">
            <label class="control-label">Language specific voice id</label>
            <multilang-editor [model]="currentMood?.languageTtsVoiceId" [simple]="true" [editMode]="true" [htmlMode]="false" 
              [languages]="languages" [defaultLang]="game?.defaultLang"></multilang-editor>
          </div>
          <div class="row">
            <div class="col-12">
              <label for="cluePoints">Image</label>
              <app-media-selector type="image" [gameId]="gameId" [templateId]="templateId" [fileURL]="currentMood.fileURL" (mediaUpdated)="moodImageUpdated($event)"></app-media-selector>
            </div>
          </div>
        </div>

      </nb-card-body>
    </nb-card>
  </nb-card-body>
  <nb-card-footer>
    <div class="row">
      <button class="cancel" nbButton status="danger" (click)="cancel()">Cancel</button>
      <button class="save" nbButton status="success" (click)="save()">Save</button>
    </div>
  </nb-card-footer>
</nb-card>
